<script setup lang="ts">
import './assets/style.scss'
import { VIcons } from '@/shared/ui'
import { mergeProps, ref } from 'vue'

defineProps({
  label: {
    type: String,
    default: 'itf.settings',
  },
  icon: {
    type: String,
    default: 'tune',
  },
})

const open = ref(false)
</script>

<template>
  <VMenu v-model="open" :close-on-content-click="false">
    <template #activator="{ props: menuProps }">
      <VTooltip location="top" :open-delay="500" :text="$t('itf.filter')">
        <template #activator="{ props: tooltipProps }">
          <VBtn color="primary" v-bind="mergeProps(menuProps, tooltipProps)">
            <template #prepend>
              <VIcons :type="icon" />
            </template>

            <template #append>
              <VIcons :class="open ? 'v-map-settings__open' : ''" type="arrow_drop_down" />
            </template>

            <span class="hide_mobile">{{ $t('itf.filter') }}</span>
          </VBtn>
        </template>
      </VTooltip>
    </template>

    <VCard>
      <div class="v-map-settings__form">
        <slot />
      </div>
    </VCard>
  </VMenu>
</template>
